export default __webpack_public_path__ + "static/media/south-africa.6495286c.svg";